import { Loader } from '@/shared'
import { type IDoctorCard } from '@App/types/doctorsType'
import { common } from '@App/utils'

import style from './Name.module.scss'

interface IProps {
    doctorCard: IDoctorCard | null
}

export const Name = (props: IProps) => {
    const { doctorCard } = props
    return (
        <div className={style.container}>
            {doctorCard ? (
                <span>
                    {common.fioHandler(
                        { iname: doctorCard.iname, fname: doctorCard.fname, oname: doctorCard.oname },
                        'fullname'
                    )}
                </span>
            ) : (
                <Loader />
            )}
        </div>
    )
}
